import { useState } from 'react';
import './BottomBar.css'
let BottomBar=(props)=>{
    let count=0;
    
    // document.body.addEventListener("click", function(){
    //     count++;
    //     document.querySelector(".countspan").innerHTML = `User Clicks count is:- ${count}`;
    // })
    return(
        <div className='bottombarcont'>
            <span><i className='bx bxl-facebook'></i>
            <i className='bx bxl-whatsapp' ></i>
            
            </span>
            <span className='allrightsrec'><span className='attheratecont'>@</span> All Rights Received</span>
            <span> 
                <span className='countspan'></span> 
               
            
            </span> 
        </div>
    );
}
export default BottomBar;   